<app-table
    [pageSize]="7"
    [allowedPageSizes]="[7]"
    [showPageSizeSelector]="false"
    [data]="learningPathsProgressData"
    [columns]="learningPathsProgressColumns"
    (onRowClick)="onLearningPathClick($event)"
></app-table>